/* tslint:disable */
/* eslint-disable */
/**
 * Atlas API
 * Atlas API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CategoryDelegationStats,
    CategoryDelegationStatsFromJSON,
    CategoryDelegationStatsFromJSONTyped,
    CategoryDelegationStatsToJSON,
    DelegationSummary,
    DelegationSummaryFromJSON,
    DelegationSummaryFromJSONTyped,
    DelegationSummaryToJSON,
} from './';

/**
 * 
 * @export
 * @interface DelegationsCreated
 */
export interface DelegationsCreated {
    /**
     * 
     * @type {CategoryDelegationStats}
     * @memberof DelegationsCreated
     */
    categoryStats?: CategoryDelegationStats;
    /**
     * 
     * @type {Array<DelegationSummary>}
     * @memberof DelegationsCreated
     */
    created: Array<DelegationSummary>;
}

export function DelegationsCreatedFromJSON(json: any): DelegationsCreated {
    return DelegationsCreatedFromJSONTyped(json, false);
}

export function DelegationsCreatedFromJSONTyped(json: any, ignoreDiscriminator: boolean): DelegationsCreated {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryStats': !exists(json, 'category_stats') ? undefined : CategoryDelegationStatsFromJSON(json['category_stats']),
        'created': ((json['created'] as Array<any>).map(DelegationSummaryFromJSON)),
    };
}

export function DelegationsCreatedToJSON(value?: DelegationsCreated | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category_stats': CategoryDelegationStatsToJSON(value.categoryStats),
        'created': ((value.created as Array<any>).map(DelegationSummaryToJSON)),
    };
}


